module.exports = __webpack_public_path__ + "static/media/logo.95418430.png";